'use strict';

/*============================================================================
  Since this method has ES6 code in it, it belongs here... Slate is no good :)
==============================================================================*/
ShopifyAPI.packlaboAjax = function(
	method,
	url,
	data,
	loadMessage,
	mainCallBack,
	errorCallback,
	...remainingCallbacks
) {
	let loadingMessageLogic = (function() {
		$('#loadingDivToDestroy').addClass('active');
		let destroyLoadingMessage = () =>
			$('#loadingDivToDestroy').removeClass('active');
		return destroyLoadingMessage;
	})();

	if (loadMessage) remainingCallbacks.push(loadingMessageLogic);

	let params = {
		type: method,
		url: url,
		data: data,
		dataType: 'json',
		success: (cart) => mainCallBack(cart, remainingCallbacks),
		error:
			typeof errorCallback == 'function'
				? (error) => errorCallback(error, loadingMessageLogic)
				: (XMLHttpRequest, textStatus) => [
						ShopifyAPI.onError(XMLHttpRequest, textStatus),
						loadingMessageLogic(),
				  ],
	};
	jQuery.ajax(params);
}; // Used for resizing images based on the Shopify CDN

var AssetImage = function AssetImage(url, is_original) {
	var self = this;
	this.url = url;
	this.is_original = is_original;
	var image_sizes = 'pico icon thumb small compact medium large grande 1024x1024 2048x2048 master original'.split(
		' '
	);

	function resize(size) {
		// Don't resize images that aren't from Shopify, duh!
		if (!self.url.indexOf('cdn.shopify.com') < 0) {
			return self.url;
		} // Set size to nothing if no size is provided

		size = size ? size : ''; // Pick apart the url and rebuild it

		var sizes = '_' + image_sizes.join('|_');
		var filetype = '(\\.(jpg|jpeg|png|gif)+\\??.*)';

		if (self.is_original) {
			var format = new RegExp(filetype, 'i');
			return {
				original: self.url,
				resized: url.replace(format, '_' + size + '$1'),
			};
		} else {
			var format = new RegExp('(' + sizes + ')' + filetype, 'i');
			return {
				original: self.url.replace(format, '$2'),
				resized: self.url.replace(format, '_' + size + '$2'),
			};
		}
	}

	this.original = function() {
		return resize().original;
	};

	this.resized = function(size) {
		return resize(size).resized;
	};
};

(function($) {
	// Filters
	// function catalog_filters() {
	//   var $filters = $('.filters');
	//   $filters.find('.filter').on('click', function () {
	//     $(this).toggleClass('active').next().slideToggle(200, function () {
	//       $(document.body).trigger("sticky_kit:recalc");
	//     });
	//   }); // For each tag, open up that category with input checked

	//   $(Shopify.current_tags).each(function () {
	//     // Fix for "&"
	//     var tmp = this.replace(/-amp/, "");
	//     $('.filters input[name="' + tmp + '"]').prop('checked', true).closest('li').find('.filter').addClass('active').next().show();
	//   }); // When a filter selection is made, grab all check marks and format
	//   // the url to filter tags on products

	//   $filters.find('input[type="checkbox"]').on('change',function () {
	//     var fields = [];
	//     $filters.find('input[type="checkbox"]:checked').each(function () {
	//       var name = $(this).attr('name');

	//       if (fields.indexOf(name) < 0) {
	//         fields.push($(this).attr('name'));
	//       }
	//     });
	//     var url = $filters.attr('action') + "/" + fields.join("+");
	//     window.location = url;
	//   }); // on click one of the filtertags, remove it from url

	//   $(".catalog__tags--active").on("click", function (event) {
	//     event.preventDefault();
	//     var tmp = this.dataset.tag.replace(/-amp/, "");
	//     $("[name='" + tmp + "']").click(); //document.location.href=document.location.href.replace(re"[\+]?"+this.dataset.tag+"[\+]?","");

	//     return false;
	//   }); // Create labels for colors

	//   String.prototype.capitalize = function () {
	//     return this.charAt(0).toUpperCase() + this.slice(1);
	//   }; // $('.filter-by-color input[type="checkbox"]').each(function() {
	//   //   var color = $(this).attr('name');
	//   //   var id = 'filter-by-' + color;
	//   //   $(this).attr('id', id);
	//   //   var $label = $('<label><span class="tooltiptext btn">'+color.capitalize()+'</span></label>').attr('for', id).addClass(color);
	//   //   $(this).before($label);
	//   // });
	//   // Don't submit the form

	//   $filters.on('submit', function (event) {
	//     event.preventDefault();
	//   });
	// }

	function tabs() {
		
		var hash = window.location.hash;

		if (hash) {
			activate_tab(hash.replace('#', ''));
		}

		var tab = hash.replace('#', '');
		var selector = '*[data-tab="' + tab + '"]';
		var $tab = $(selector);
		var $tabular = $tab.first().closest('.tabular');
		var $new_codetabularActive = '';


		if (hash.length != 0) {
			var $tabularActive = $tab
				.first()
				.closest('.tabular')
				.find('.tab.active')
				.find('[data-color-code]');
			var $new_codetabularActive = $tabularActive.text();
		} else {
			var $tabularActive = $('.tab.active').find('[data-color-code]');
			var $new_codetabularActive = $tabularActive.text();
		}

		$('.color-code').text($new_codetabularActive);

		function activate_tab(tab) {
			var selector = '*[data-tab="' + tab + '"]';
			var $tab = $(selector);
				console.log("tab:", tab);
			console.log("selector:", selector);

			if ($tab.length < 1) {
				return;
			}

			var $tabular = $tab.first().closest('.tabular'); // Assign classes

			$tabular
				.find('.active')
				.removeClass('active')
				.end()
				.find(selector)
				.addClass('active');
			window.location.hash = tab;

			var $tabularActive = $tab
				.first()
				.closest('.tabular')
				.find('.tab.active')
				.find('[data-color-code]');

			var $new_codetabularActive = $tabularActive.text();
			$('.color-code').text($new_codetabularActive);
		}

		$('.tabular .tabs a').click(function(event) {
			event.preventDefault();
			activate_tab($(this).attr('data-tab'));
		});
	}

	function slick() {
		$('.slick-items').slick({
			infinite: true,
			slidesToShow: 8,
			slidesToScroll: 8,
			dots: false,
			arrows: true,
			speed: 500,
			responsive: [
				{
					breakpoint: 1000,
					settings: {
						slidesToShow: 10,
						slidesToScroll: 10,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 7,
						slidesToScroll: 7,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 5,
					},
				},
			],
		});
		$('.slick-items-deco').slick({
			infinite: true,
			slidesToShow: 7,
			slidesToScroll: 2,
			dots: false,
			arrows: true,
			speed: 500,
			responsive: [
				{
					breakpoint: 1100,
					settings: {
						slidesToShow: 6,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 350,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});
		$('.slick-items-var').slick({
			infinite: true,
			slidesToShow: 3,
			slidesToScroll: 2,
			dots: false,
			arrows: true,
			speed: 500,
			responsive: [
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 350,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});
		$('.slick-items-outletOther').slick({
			infinite: true,
			slidesToShow: 5,
			slidesToScroll: 5,
			dots: false,
			arrows: true,
			speed: 500,
			responsive: [
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 5,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 500,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 350,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
			],
		});
	} //OLD CODE FOR LOCALIZE

	// function languages_select() {
	//   var $fields = $('.language-select');
	//   $fields.change(function () {
	//     // Set all other fields the same
	//     $fields.val($(this).val());
	//     bablic.redirectTo($(this).val()); //Localize.setLanguage();
	//     //console.log("hello");
	//   }); //console.log(Localize.getLanguage());
	//   // Set selects
	//
	//   $fields.val(bablic.getLocale());
	// }

	function toggle_color_codes() {
		$('.specs .tabs a').click(function() {
			var $code = $(this)
				.closest('.tabular')
				.find('.tab.active')
				.find('[data-color-code]');
			var new_code = $code.text();
			var prev_code = $('.color-code')
				.first()
				.text(); // This replaces the H1 title on click

			$('.color-code').text(new_code);
			$('title').text(
				$('title')
					.text()
					.replace(prev_code, new_code)
			);
		});
	} // On DOM load

	$(function() {
		// catalog_filters();
		tabs();
		slick(); // OLD CODE FOR LOCALIZE

		// languages_select();
		toggle_color_codes();
	}); // HOVER EFFECT

	$('.site-nav--has-dropdown').on(
		'hover',
		function() {
			$('header').addClass('hoverActive');
		},
		function() {
			$('header').removeClass('hoverActive');
		}
	);
})(jQuery);
/*! npm.im/object-fit-images 3.2.3 */

var objectFitImages = (function() {
	'use strict';

	function t(t, e) {
		return (
			"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
			t +
			"' height='" +
			e +
			"'%3E%3C/svg%3E"
		);
	}

	function e(t) {
		if (t.srcset && !m && window.picturefill) {
			var e = window.picturefill._;
			(t[e.ns] && t[e.ns].evaled) ||
				e.fillImg(t, {
					reselect: !0,
				}),
				t[e.ns].curSrc ||
					((t[e.ns].supported = !1),
					e.fillImg(t, {
						reselect: !0,
					})),
				(t.currentSrc = t[e.ns].curSrc || t.src);
		}
	}

	function i(t) {
		for (
			var e, i = getComputedStyle(t).fontFamily, r = {};
			null !== (e = l.exec(i));

		) {
			r[e[1]] = e[2];
		}

		return r;
	}

	function r(e, i, r) {
		var n = t(i || 1, r || 0);
		p.call(e, 'src') !== n && b.call(e, 'src', n);
	}

	function n(t, e) {
		t.naturalWidth ? e(t) : setTimeout(n, 100, t, e);
	}

	function c(t) {
		var c = i(t),
			o = t[a];

		if (((c['object-fit'] = c['object-fit'] || 'fill'), !o.img)) {
			if ('fill' === c['object-fit']) return;
			if (!o.skipTest && g && !c['object-position']) return;
		}

		if (!o.img) {
			(o.img = new Image(t.width, t.height)),
				(o.img.srcset = p.call(t, 'data-ofi-srcset') || t.srcset),
				(o.img.src = p.call(t, 'data-ofi-src') || t.src),
				b.call(t, 'data-ofi-src', t.src),
				t.srcset && b.call(t, 'data-ofi-srcset', t.srcset),
				r(t, t.naturalWidth || t.width, t.naturalHeight || t.height),
				t.srcset && (t.srcset = '');

			try {
				s(t);
			} catch (t) {
				window.console && console.warn('https://bit.ly/ofi-old-browser');
			}
		}

		e(o.img),
			(t.style.backgroundImage =
				'url("' + (o.img.currentSrc || o.img.src).replace(/"/g, '\\"') + '")'),
			(t.style.backgroundPosition = c['object-position'] || 'center'),
			(t.style.backgroundRepeat = 'no-repeat'),
			(t.style.backgroundOrigin = 'content-box'),
			/scale-down/.test(c['object-fit'])
				? n(o.img, function() {
						o.img.naturalWidth > t.width || o.img.naturalHeight > t.height
							? (t.style.backgroundSize = 'contain')
							: (t.style.backgroundSize = 'auto');
				  })
				: (t.style.backgroundSize = c['object-fit']
						.replace('none', 'auto')
						.replace('fill', '100% 100%')),
			n(o.img, function(e) {
				r(t, e.naturalWidth, e.naturalHeight);
			});
	}

	function s(t) {
		var e = {
			get: function get(e) {
				return t[a].img[e || 'src'];
			},
			set: function set(e, i) {
				return (
					(t[a].img[i || 'src'] = e), b.call(t, 'data-ofi-' + i, e), c(t), e
				);
			},
		};
		Object.defineProperty(t, 'src', e),
			Object.defineProperty(t, 'currentSrc', {
				get: function get() {
					return e.get('currentSrc');
				},
			}),
			Object.defineProperty(t, 'srcset', {
				get: function get() {
					return e.get('srcset');
				},
				set: function set(t) {
					return e.set(t, 'srcset');
				},
			});
	}

	function o(t, e) {
		var i = !h && !t;
		if (((e = e || {}), (t = t || 'img'), (f && !e.skipTest) || !d)) return !1;
		'img' === t
			? (t = document.getElementsByTagName('img'))
			: 'string' == typeof t
				? (t = document.querySelectorAll(t))
				: 'length' in t || (t = [t]);

		for (var r = 0; r < t.length; r++) {
			(t[r][a] = t[r][a] || {
				skipTest: e.skipTest,
			}),
				c(t[r]);
		}

		i &&
			(document.body.addEventListener(
				'load',
				function(t) {
					'IMG' === t.target.tagName &&
						o(t.target, {
							skipTest: e.skipTest,
						});
				},
				!0
			),
			(h = !0),
			(t = 'img')),
			e.watchMQ &&
				window.addEventListener(
					'resize',
					o.bind(null, t, {
						skipTest: e.skipTest,
					})
				);
	}

	var a = 'bfred-it:object-fit-images',
		l = /(object-fit|object-position)\s*:\s*([-\w\s%]+)/g,
		u =
			'undefined' == typeof Image
				? {
						style: {
							'object-position': 1,
						},
				  }
				: new Image(),
		g = 'object-fit' in u.style,
		f = 'object-position' in u.style,
		d = 'background-size' in u.style,
		m = 'string' == typeof u.currentSrc,
		p = u.getAttribute,
		b = u.setAttribute,
		h = !1;
	return (
		(o.supportsObjectFit = g),
		(o.supportsObjectPosition = f),
		(function() {
			function t(t, e) {
				return t[a] && t[a].img && ('src' === e || 'srcset' === e)
					? t[a].img
					: t;
			}

			f ||
				((HTMLImageElement.prototype.getAttribute = function(e) {
					return p.call(t(this, e), e);
				}),
				(HTMLImageElement.prototype.setAttribute = function(e, i) {
					return b.call(t(this, e), e, String(i));
				}));
		})(),
		o
	);
})();
/* Share button - Facebook */

(function(d, s, id) {
	var js,
		fjs = d.getElementsByTagName(s)[0];
	if (d.getElementById(id)) return;
	js = d.createElement(s);
	js.id = id;
	js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.7';
	fjs.parentNode.insertBefore(js, fjs);
})(document, 'script', 'facebook-jssdk');

/* Scroll Navbar Shrink */

$(document).on('scroll', function() {
	if ($(document).scrollTop() > 50) $('header').addClass('shrink');
	else $('header').removeClass('shrink');
});
$(document).ready(function($) {
	/* Animation on click */
	$('a[href^="#"]').on('click', function(event) {
		var target = $($(this).attr('href'));

		if (target.length) {
			event.preventDefault();
			$('html, body')
				.stop(true, true)
				.animate(
					{
						scrollTop: target.offset().top,
					},
					800
				);
			return false;
		}
	});
	/* Footer on focus */

        var newsletter_interest = $('.newsletter_interest');
        newsletter_interest.hide();
        $('#email--newsletter').focus(function() {
                newsletter_interest.slideDown();
        });
	/* Object Image Fit */

	$(function() {
		objectFitImages();
	});
	/* Cookies */

	// var cookieMazzucchelli = $.cookie('cookieMazzucchelli');

	// if (cookieMazzucchelli === '') {
	// } else {
	// 	$('#cookie_wrapper')
	// 		.css('display', 'flex')
	// 		.find('.close')
	// 		.on('click', function() {
	// 			$(this)
	// 				.parent()
	// 				.hide();
	// 		});
	// 	var expireDate = new Date();
	// 	expireDate.setDate(expireDate.getDate() + 365 * 10);
	// 	document.cookie = 'cookieMazzucchelli =  ; expires=' + expireDate + '';
	// }
	/* Side bar login */

	var loginDrawerTitleWrapper = $('#loginDrawer').find('.drawer__title'),
		loginDrawerLogin = $('#sideBarLogin'),
		loginDrawerLoginTitle = $('#sideBarLoginTitle'),
		loginDrawerRegister = $('#sideBarRegister'),
		loginDrawerRegisterTitle = $('#sideBarRegisterTitle');

	var switchLoginView = function switchLoginView(
		loginDisplay,
		registerDisplay,
		title
	) {
		loginDrawerTitleWrapper.html(title);
		loginDrawerLogin.css('display', loginDisplay);
		loginDrawerRegister.css('display', registerDisplay);
		return false;
	};

	$('#sidebarLoginHref').on(
		'click',
		switchLoginView.bind(this, 'none', 'block', loginDrawerRegisterTitle.val())
	);
	$('#sideBarRegisterHref').on(
		'click',
		switchLoginView.bind(this, 'block', 'none', loginDrawerLoginTitle.val())
	);

	/* Form HoneyPot */
	const HoneypotContainer = document.getElementsByClassName('hp-bcontrol');

	Array.from(HoneypotContainer).forEach((hPCont) => {
		hPCont.parentElement.addEventListener('submit', (event) => {
			let honeypot = hPCont.querySelector('input');
			if (honeypot.value && honeypot.value !== '') {
				event.preventDefault();
			}
		});
	});

	/* User action modal setup */

	var userActionModalSetup = function userActionModalSetup() {
		var _ref =
				arguments.length > 0 && arguments[0] !== undefined
					? arguments[0]
					: functions,
			firstButton = _ref.firstButton,
			secondButton = _ref.secondButton,
			thirdButton = _ref.thirdButton;

		var modal = $('#userActionModal--wrapper');
		$('#userActionModal--firstButton').on(
			'click',
			firstButton
				? firstButton
				: function() {
						return modal.toggleClass('active');
				  }
		);
		if (secondButton)
			$('#userActionModal--secondButton').on('click', secondButton);
		$('#userActionModal--thirdButton').on(
			'click',
			thirdButton
				? thirdButton
				: function() {
						return (document.location.href = '/cart');
				  }
		);
	};
	/* Dispatch actions according to page */

	var dispatchActionsAfterTemporaryCode = function dispatchActionsAfterTemporaryCode() {
		var userActionModalFunctions = {};
		switch (timber.cache.$body.attr('id')) {
			case 'wishlist':
				//Overrides href="/cart" to "/pages/wishlist"
				$('.remove-from-cart').on('click', function(e) {
					e.preventDefault();
					fetch(e.target.href).then(function() {
						return (document.location.href = '/pages/wishlist');
					});
				});
				break;

			case 'creative-case':
				filtersPacklabo();
				userActionModalFunctions = packlaboAjax();
				break;

			case 'decorative-case':
				filtersPacklabo();
				userActionModalFunctions = packlaboAjax();
				break;

			case 'big-decorative-case':
				filtersPacklabo();
				userActionModalFunctions = packlaboAjax();
				break;

			case 'your-shopping-cart':
				userActionModalFunctions = cartAjax();
				break;

			case 'shape-your-ideas':
				configuratorAjax();
				break;

			default:
				break;
		}
		let outletCatalog = document.getElementById('cat--outletBanner');
		if (outletCatalog) {
			filtersThickness();
		}
		userActionModalSetup(userActionModalFunctions);
	};
	/* Restore wishlist products if they are present in cookies */

	var restoreWishlistProductsFromCookies = function restoreWishlistProductsFromCookies() {
		var wishlistProductsToRestore = [],
			cookieString = 'wishlistProduct',
			cookiesArray = document.cookie.split(';'),
			cookieStringRegExp = RegExp(cookieString);

		var exitFunction = function exitFunction(line_item, callbacks) {
			if (callbacks)
				callbacks.forEach(function(item) {
					return item();
				});
			dispatchActionsAfterTemporaryCode();
		};

		var addToCart_isRecursive = function addToCart_isRecursive(
			line_item,
			callbacks
		) {
			var _ShopifyAPI;

			if (callbacks)
				callbacks.forEach(function(item) {
					return item();
				});

			var productToSubmit = wishlistProductsToRestore.shift(),
				isLastProduct = !wishlistProductsToRestore.length,
				referenceToThisCallBack = function referenceToThisCallBack() {
					return (document.cookie = ''.concat(
						productToSubmit.cookie,
						'=; expires=Thu, 01 Jan 1970 00:00:00 GMT'
					));
				},
				functionParameters = [
					'POST',
					'/cart/add.js',
					'id='
						.concat(productToSubmit.id, '&quantity=1&properties%5Btype%5D=')
						.concat(productToSubmit.type, '&properties%5B_carry%5D=wishlist'),
					isLastProduct ? true : false,
					isLastProduct ? exitFunction : addToCart_isRecursive,
					false,
					referenceToThisCallBack,
				];

			(_ShopifyAPI = ShopifyAPI).packlaboAjax.apply(
				_ShopifyAPI,
				functionParameters
			);
		};

		cookiesArray.forEach(function(item) {
			var cookieToSplit = item.split('='),
				cookieName = cookieToSplit[0].substr(1),
				productValues = cookieToSplit[1].split(',');
			if (cookieStringRegExp.test(item))
				wishlistProductsToRestore.push({
					id: productValues[0],
					type: productValues[1],
					cookie: cookieName,
				});
		});
		if (wishlistProductsToRestore.length) addToCart_isRecursive();
		else dispatchActionsAfterTemporaryCode();
	};
	/* Temporary code beginning - Adapt old cart to the new properties cart logic */

	var addCarryPropToOldItems = function addCarryPropToOldItems(cart) {
		var line = getItemsWithoutCarryProp(cart);

		if (line.length) {
			var params = {
				type: 'POST',
				url: '/cart/change.js',
				data:
					'properties%5Btype%5D=' +
					line[1] +
					'&properties%5B_carry%5D=wishlist&line=' +
					line[0],
				dataType: 'json',
				success: function success(cart) {
					return addCarryPropToOldItems(cart);
				},
				error: function error(XMLHttpRequest, textStatus) {
					return ShopifyAPI.onError(XMLHttpRequest, textStatus);
				},
			};
			jQuery.ajax(params);
		} else {
			if (
				cart.items.some(function(item) {
					return item.properties._carry == 'wishlist';
				})
			)
				$('#cartCount, #cartCount-mob')
					.html(updateWishListCount(cart.items))
					.addClass('cart-link__bubble--visible');
			restoreWishlistProductsFromCookies();
		}
	};

	var getItemsWithoutCarryProp = function getItemsWithoutCarryProp(cart) {
		for (var i = 0, length = cart.items.length; i < length; i++) {
			if (!cart.items[i].properties._carry)
				return [i + 1, cart.items[i].properties.type];
		}

		return [];
	};

	ShopifyAPI.getCart(addCarryPropToOldItems);
	/* Temporary code end */
});

// FILTER OUTLET CATALOG
function _slicedToArray(arr, i) {
	return (
		_arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest()
	);
}

function _nonIterableRest() {
	throw new TypeError('Invalid attempt to destructure non-iterable instance');
}

function _iterableToArrayLimit(arr, i) {
	if (
		!(
			Symbol.iterator in Object(arr) ||
			Object.prototype.toString.call(arr) === '[object Arguments]'
		)
	) {
		return;
	}
	var _arr = [];
	var _n = true;
	var _d = false;
	var _e = undefined;
	try {
		for (
			var _i = arr[Symbol.iterator](), _s;
			!(_n = (_s = _i.next()).done);
			_n = true
		) {
			_arr.push(_s.value);
			if (i && _arr.length === i) break;
		}
	} catch (err) {
		_d = true;
		_e = err;
	} finally {
		try {
			if (!_n && _i['return'] != null) _i['return']();
		} finally {
			if (_d) throw _e;
		}
	}
	return _arr;
}

function _arrayWithHoles(arr) {
	if (Array.isArray(arr)) return arr;
}

function filtersThickness() {
	'use strict'; // Private variables

	var filterCache = {},
		noMatchFoundWrapper,
		packlaboSlider,
		allProducts,
		allProductsBasicCN,
		AmountCheckboxes,
		allCollections; // Private functions

	var init,
		eventListeners,
		filterAllProducts,
		resetAllProducts,
		resetFilterCache,
		toggleNoMatchFound;

	init = function init() {
		resetFilterCache();
		noMatchFoundWrapper = $('#filtersForm--noMatchFound');
		packlaboSlider = document.getElementById('packLabo--slider');
		allProducts = [].slice.call(
			document.getElementsByClassName('product-card')
		);
		allProductsBasicCN = allProducts[0].className.replace(/active/, '').trim();
		AmountCheckboxes = $('#filter-by-amount').find('input[type="checkbox"]');
		allCollections = document.getElementsByClassName('collection-products');
		// configuratorBanner = document.getElementById('configurator-banner-wrapper');
	};
	// console.log('AmountCheckboxes', AmountCheckboxes);
	// console.log($("#filter-by-amount").find('input[type="checkbox"]'));
	eventListeners = function eventListeners() {
		noUiSlider.create(packlaboSlider, {
			start: [3.0, 8.0],
			tooltips: [
				wNumb({
					decimals: 1,
				}),
				wNumb({
					decimals: 1,
				}),
			],
			step: 0.1,
			range: {
				min: [3.0],
				max: [8.0],
			},
		});
		packlaboSlider.noUiSlider.on('update', function(values) {
			filterCache.thickness = values.map(function(item) {
				return item.slice(0, -1);
			});
			filterAllProducts();
		});
		// AmountCheckboxes.forEach(checkbox => {
		//   console.log(checkbox);
		// })
		AmountCheckboxes.change(function(e) {
			var associatedLabel,
				toCache = e.target.name,
				cacheKey = e.target.closest('li').dataset.filter,
				cacheToUpdate = filterCache[cacheKey].indexOf(toCache);
			if (
				$(this)
					.prev()
					.attr('for') == e.target.id
			)
				associatedLabel = $(this).prev();
			if (cacheToUpdate > -1) {
				filterCache[cacheKey].splice(cacheToUpdate, 1);
				if (associatedLabel) associatedLabel.removeClass('active');
			} else {
				filterCache[cacheKey].push(toCache);
				if (associatedLabel) associatedLabel.addClass('active');
			}

			filterAllProducts();
		});
		// $("#filtersForm--clearFilters").on("click", function () {
		//   return [resetFilterCache(), resetAllProducts()];
		// }); // !IMPORTANT!
		// This event listener of "packlabo filters" overwrites line 166 of theme.js.liquid that sets javascript of "catalog filters"
		// To overwrite seemed more straightforward than redo and retest old existing code...
	};

	filterAllProducts = function filterAllProducts() {
		Array.from(allCollections).forEach((collection) => {
			collection.classList.remove('active');
		});
		var aMatchIsFound = false,
			_filterCache$thicknes = _slicedToArray(filterCache.thickness, 2),
			minRange = _filterCache$thicknes[0],
			maxRange = _filterCache$thicknes[1],
			isFilterInThickness = function isFilterInThickness(variant) {
				return (
					+variant.thickness >= +minRange && +variant.thickness <= +maxRange
				);
			},
			isFilterInAvailable = function isFilterInAvailable(variant) {
				// console.log(variant.amount);
				return filterCache.amount.length
					? filterCache.amount.some(function(itemCache) {
							if (itemCache == 'moreThan30') {
								return variant.amount > 30;
							} else if (itemCache == 'lessThan10') {
								return variant.amount < 10;
							} else {
								return variant.amount <= 30 && variant.amount >= 10;
							}
					  })
					: true;
			};
		// if (filterCache.color.length > 0 || filterCache.material.length > 0 || minRange !== "3.0" || maxRange !== "8.0") {
		//   configuratorBanner.style.display = "none";
		// } else {
		//   configuratorBanner.style.display = "flex";
		// }
		// console.log({filterCache});
		allProducts.forEach(function(item) {
			aMatchIsFound = false;
			Array.from(JSON.parse(`[${item.dataset.thickness}]`)).some((variant) => {
				if (isFilterInThickness(variant) && isFilterInAvailable(variant)) {
					aMatchIsFound = true;
				}
			});
			if (aMatchIsFound) {
				item.className = allProductsBasicCN + ' active';
				item.parentElement.classList.add('active');
			} else {
				item.className = allProductsBasicCN;
			}
		});
		// toggleNoMatchFound(!aMatchIsFound ? "addClass" : "removeClass");
	};

	resetAllProducts = function resetAllProducts() {
		toggleNoMatchFound('removeClass');
		packlaboSlider.noUiSlider.set([3.0, 8.0]);
		AmountCheckboxes.prop('checked', false);
		allProducts.forEach(function(item) {
			return (item.className = allProductsBasicCN + ' active');
		});
		document
			.getElementById('filter-by-color--wrapper')
			.querySelectorAll('label')
			.forEach((label, i) => {
				label.classList.remove('active');
			});
	};

	resetFilterCache = function resetFilterCache() {
		filterCache.amount = [];
	};

	toggleNoMatchFound = function toggleNoMatchFound(method) {
		return noMatchFoundWrapper[method]('active');
	};

	init();
	eventListeners();
}
